import React from 'react';
import { Spinner, UpliftThemeProvider } from '@uplift/ui-v2';
import { MainLayout } from '../../components';
import { ProviderCard } from '../components';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { ArchivedProviders } from './components/archived-providers/archived-providers.component';
import { NotMatchedWithTherapist } from './components/not-matched-with-therapist/not-matched-with-therapist';
import { ProviderMedicalRole } from '@uplift/types';
import { useCurrentuser } from '@uplift/contexts';
import { usePatientDetailsQuery, useUserMatchesQuery } from '@uplift/queries';


const useStyles = makeStyles()(theme => ({
  providerCardsWrapper: {
    maxWidth: '100%',

    [theme.breakpoints.up('sm')]: {
      maxWidth: '422px',
    }
  },
  providerCardWrapper: {
    marginBottom: theme.spacing(4),
  },
}));


const CareTeamPageContent: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const me = useCurrentuser();
  const { data: patientDetails } = usePatientDetailsQuery(me.id, { suspense: true });
  const { data: matches, isLoading: isMatchesLoading } = useUserMatchesQuery(me.id, undefined, { suspense: true });
  const matchedWithTherapist = matches?.activeMatches?.find(m => m.provider.medicalRole === ProviderMedicalRole.therapist);
  const isBetterhelpUser = patientDetails?.isBetterhelpUser;

  return (
    <UpliftThemeProvider>
      <Box mb={5}>
        <Typography variant="h2">{l10n.pages.yourCareTeam}</Typography>
      </Box>
      <Box className={classes.providerCardsWrapper}>
        {!isMatchesLoading && !matchedWithTherapist && !isBetterhelpUser && (
          <Box className={classes.providerCardWrapper}>
            <NotMatchedWithTherapist />
          </Box>
        )}
        {(matches?.activeMatches || []).map(match => (
          <Box key={match.match.id} className={classes.providerCardWrapper}>
            <ProviderCard
              matchId={match.match.id}
              provider={match.provider}
            />
          </Box>
        ))}
        <ArchivedProviders />
        {isMatchesLoading && !matches ? <Box my={20}><Spinner /></Box> : null}
      </Box>
    </UpliftThemeProvider>
  );
};


export const CareTeamPage: React.VFC = () => {
  return (
    <MainLayout>
      <CareTeamPageContent />
    </MainLayout>
  );
};
